<template>
  <b-container>
    <div>
      <h1>{{ $t("checklist.form.fillDetails") }}</h1>
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    </div>
    <b-row>
      <b-col>
        <!-- {{moduleId}} -->
        <router-link :to="getUrlBackToList">
          <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
        </router-link>
        <!-- Botão da empresas q possui layout próprio -->
        <b-button
          v-if="companyId == 178 || companyId == 259"
          size="sm"
          class="ml-2"
          @click="exportPdf()"
          >{{ $t("geral.exportPdf") }}
        </b-button>
        <!-- Botão para as empresas com o layout padrão -->
        <b-button v-else size="sm" class="ml-2" @click="openModal()">
          {{ $t("geral.exportPdf") }}
        </b-button>

        <b-modal
          id="modal-scrollable"
          class="kanban-modal"
          scrollable
          size="lg"
          ref="openModal"
          :title="$t('geral.exportPdf')"
        >
          <checklist-pdf-export-parameters :params.sync="parameters" />

          <!-- <label>{{ $t("geral.exportType") }}</label>
          <b-form-select
            v-model="optionsExport"
            id="optionsExport"
            :options="optionsExportPdf"
          >
          </b-form-select> -->

          <template #modal-footer="{ cancel }">
            <div class="right">
              <b-button variant="green" @click="exportPdfV2()">
                {{ $t("geral.confirm") }}
              </b-button>
              <b-button class="ml-2" variant="danger" @click="cancel()">
                {{ $t("geral.cancel") }}
              </b-button>
            </div>
          </template>
        </b-modal>
      </b-col>
    </b-row>
    <b-row class="mb-3 ml-0">
      <b-col> </b-col>
      <b-col> </b-col>
    </b-row>
    <b-row>
      <b-col lg="8" md="8" sm="12">
        <b-form-group
          label="Formulario"
          label-for="input-formName"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            type="text"
            id="input-formName"
            v-model="checklist.formName"
            readonly
          />
        </b-form-group>
        <b-form-group
          label="Data preenchimento"
          label-for="input-dateFill"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            type="text"
            id="input-dateFill"
            v-model="formatedDateFill"
            readonly
          />
        </b-form-group>
        <b-form-group
          label="Responsável preenchimento"
          label-for="input-userFillName"
          label-cols-sm="5"
          label-cols-md="5"
          label-cols-lg="5"
        >
          <b-form-input
            type="text"
            id="input-userFillName"
            v-model="checklist.userFillName"
            readonly
          />
        </b-form-group>
      </b-col>
    </b-row>

    <h2>{{ $t("checklist.form.values") }}</h2>

    <div v-if="hasAttachments">
      <b-button
        v-if="!isShowingEveryAttachments"
        size="sm"
        @click="showAllAttachments"
      >
        {{ $t("geral.showAllAttachments") }}
      </b-button>
      <b-button
        v-if="isShowingEveryAttachments"
        size="sm"
        @click="hideEveryAttachments"
      >
        {{ $t("geral.hideAllAttachments") }}
      </b-button>
    </div>

    <div v-for="value in checklist.values" :key="value.id">
      <b-row>
        <b-col lg="8" md="8" sm="12">
          <checklist-filled-details-field
            ref="checklistFilledDetailsField"
            :checklist-value="value"
            @after-attachment-show="verifyShowingEveryAttachments"
          >
          </checklist-filled-details-field>
        </b-col>
      </b-row>
    </div>
    <!-- <div>{{checklist}}</div> -->
    <!-- <pre class="language-json"><code>{{ checklist  }}</code></pre> -->
  </b-container>
</template>

<script>
import ChecklistFilledDetailsField from "@/components_rms/checklist/filled/ChecklistFilledDetailsField.vue";
export default {
  name: "ModuleDetailedForm",
  props: {
    id: String,
    moduleId: String,
    itemId: String,
  },
  components: {
    ChecklistFilledDetailsField,
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    ChecklistPdfExportParameters: () =>
      import(
        "@/components_rms/checklist/fill/ChecklistPdfExportParameters.vue"
      ),
  },
  directives: {},
  data: function () {
    return {
      alert: {
        error: "",
      },
      checklist: {},
      fullscreenAttachment: "",
      hasAttachments: false,
      isShowingEveryAttachments: false,
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsExportPdf: [
        { value: 0, text: "Exportação completa" },
        { value: 1, text: "Exportação sem fotos" },
        { value: 2, text: "Exportação sem campos vazios" },
        { value: 3, text: "Exportação sem fotos/sem campos vazios" },
      ],
      optionsExport: 0,
      parameters: {
        optionMode: 1,
        optionSize: 1,
      },
      companyId: 0,
    };
  },
  created: function () {
    //console.log(`filledDetails -> created -> id=${this.id}`);
    if (this.id) {
      //console.log('filledDetails -> created -> load');
      this.loadData();
    }
  },
  computed: {
    formatedDateFill() {
      if (this.checklist) {
        let date = new Date(this.checklist.dateFill);
        return date.toLocaleString();
      }
      return "";
    },
    getUrlBackToList() {
      return `/modulo/${this.moduleId}/${this.itemId} `;
    },
  },
  methods: {
    exportPdf() {
      this.$apiChecklist
        .request({
          url: `/checklist/exporttopdf/${this.id}`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    exportPdfV2() {
      this.$apiChecklist
        .request({
          url: `/v2/checklist/exporttopdf/${this.id}/${this.parameters.optionMode}/${this.parameters.optionSize}`,
          method: "GET",
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    reopenChecklist() {
      this.$apiChecklist
        .get(`/checklist/reopen/${this.id}`)
        .then((response) => {
          if (response.data.success == true) {
            let checklist = response.data.data;
            this.$router.push(
              `/checklist/Layout/form/Fill/${checklist.formId}/${checklist.id}`
            );
          } else {
            this.alert.error = response.data.title;
            this.$refs.fadeAlertDanger.show();
          }
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);
        });
    },
    hideEveryAttachments() {
      this.$refs.checklistFilledDetailsField.forEach((detailField) => {
        detailField.hideAttachment();
      });
      this.isShowingEveryAttachments = false;
    },
    async loadData() {
      this.$apiChecklist
        .get("/checklist/get/" + this.id.toString() + "/false")
        .then((response) => {
          let checklist = response.data.data;
          this.checklist = checklist;
          this.companyId = checklist.companyId;
          console.log(this.companyId);
          this.hasAttachments =
            this.checklist.values.filter(
              (checklistValue) => checklistValue.hasAttachment
            ).length > 0;
        })
        .catch((error) => {
          this.checklist = {};
          this.hasAttachments = false;
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    showAllAttachments() {
      this.$refs.checklistFilledDetailsField.forEach((detailField) => {
        detailField.showAttachment();
      });
      this.isShowingEveryAttachments = true;
    },
    verifyShowingEveryAttachments() {
      let total = 0;
      let showing = 0;
      this.$refs.checklistFilledDetailsField.forEach((detailField) => {
        if (detailField.checklistValue.hasAttachment) {
          total++;
          if (detailField.isShowingAttachment) {
            showing++;
          }
        }
      });
      this.isShowingEveryAttachments = total == showing;
    },
    getChecklistId() {},
    openModal() {
      this.$refs.openModal.show();
    },
  },
};
</script>
